import { render, staticRenderFns } from "./madam-size-calculator.vue?vue&type=template&id=a8e74fca&scoped=true&"
import script from "./madam-size-calculator.vue?vue&type=script&lang=js&"
export * from "./madam-size-calculator.vue?vue&type=script&lang=js&"
import style0 from "./madam-size-calculator.vue?vue&type=style&index=0&id=a8e74fca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e74fca",
  null
  
)

export default component.exports